import { Component } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import NetNewProviderHistoryEntryDisplay from "@app/projects/net-new-provider/NetNewProviderHistoryEntryDisplay";
import { NetNewProviderHistory, NetNewProviderHistoryEntry } from "@app/projects/results/net-new-provider/netNewProviderHistory";
import NetNewServicingProviderService from "@app/projects/servicing-provider/NetNewServicingProviderService";
import { Timeline } from "@app/shared/timeline/Timeline";

interface NetNewProviderHistoryProps {
  netNewProviderProjectId: number;
}

interface NetNewProviderHistoryState {
  history: NetNewProviderHistory;
  loading: boolean;
}

export default class ProjectionProviderHistoryDisplay extends Component<NetNewProviderHistoryProps, NetNewProviderHistoryState> {

  private readonly netNewProviderService = new NetNewServicingProviderService();

  constructor(props: NetNewProviderHistoryProps) {
    super(props);

    this.state = {
      history: null,
      loading: true
    }
  }

  public async componentDidMount() {
    await this.netNewProviderService.getNetNewServicingProviderHistory(this.props.netNewProviderProjectId).then((history) => {
      this.setState({
        history: history,
        loading: false
      });
    })
      .catch(() => {
        this.setState({
          history: null,
          loading: false
        });
      });

  }

  public render() {
    return (
      <>
        {this.state.loading ? <LoadingSpinner /> : <>
          {!this.state.history ? <QESAlert type="danger" persist={true}>Unable to load history for this provider.</QESAlert> : <Timeline>
            {this.state.history.netNewProviderHistoryEntries.map((entry: NetNewProviderHistoryEntry) => {
              return <NetNewProviderHistoryEntryDisplay historyEntry={entry} key={entry.historyEntryTime.valueOf()} />;
            })}
          </Timeline>}
        </>}
      </>
    );
  }
}
